<template>
  <ocr-recognition :source="INTELLIGENT_DOCUMENT_SOURCE_12.code" />
</template>

<script>
import ocrRecognition from '@/views/cargo/v0/ToolAssistant/ocrRecognition'
import {
  INTELLIGENT_DOCUMENT_SOURCE_12
} from '@/class/cargo/model/parameters/SystemConstants'
export default {
  name: 'OcrRecognitionAE',
  components: { ocrRecognition },
  data() {
    return {
      INTELLIGENT_DOCUMENT_SOURCE_12
    }
  }
}
</script>

<style scoped>

</style>
